import { Transaction } from '../../models/Transaction'
import { Chip } from '../common/fields/Chip'
import { WorkflowIconSection } from './WorkflowIconSection'
import { WorkflowPageCard } from './WorkflowPageCard'

type Props<TransactionT extends Transaction> = {
    transaction: TransactionT
    onUpdateTransaction: (updatedTransaction: TransactionT) => void
    sendViaDescription: string
    reminderDescription: string
}

export const NotificationsSection = <TransactionT extends Transaction>({
    transaction,
    onUpdateTransaction,
    sendViaDescription,
    reminderDescription,
}: Props<TransactionT>) => {
    return (
        <WorkflowPageCard title="Notifications" defaultIsCollapsed>
            <WorkflowIconSection
                title="Send via"
                icon="messageArrowUp.large"
                description={sendViaDescription}
            >
                <div className="flex flex-wrap items-center justify-start gap-x-2 gap-y-1">
                    <Chip
                        title="Don't notify"
                        isSelected={(transaction.channel ?? '') === ''}
                        onClick={() =>
                            onUpdateTransaction(transaction.clone({ channel: '' }) as TransactionT)
                        }
                        size="small"
                    />
                    <Chip
                        title="Text message"
                        isSelected={transaction.channel === 'sms'}
                        onClick={() =>
                            onUpdateTransaction(
                                transaction.clone({ channel: 'sms' }) as TransactionT
                            )
                        }
                        size="small"
                    />
                    <Chip
                        title="Text and email"
                        isSelected={transaction.channel === 'combo'}
                        onClick={() =>
                            onUpdateTransaction(
                                transaction.clone({ channel: 'combo' }) as TransactionT
                            )
                        }
                        size="small"
                    />
                    <Chip
                        title="Email"
                        isSelected={transaction.channel === 'email'}
                        onClick={() =>
                            onUpdateTransaction(
                                transaction.clone({ channel: 'email' }) as TransactionT
                            )
                        }
                        size="small"
                    />
                </div>
            </WorkflowIconSection>

            <WorkflowIconSection
                title="Payment reminder"
                icon="moneyAlarmClock.large"
                description={reminderDescription}
            >
                <div className="flex flex-wrap items-center justify-start gap-x-2 gap-y-2">
                    <Chip
                        title="Every day"
                        isSelected={(transaction.reminder ?? '1') === '1'}
                        onClick={() =>
                            onUpdateTransaction(
                                transaction.clone({ reminder: '1' }) as TransactionT
                            )
                        }
                        size="small"
                    />
                    <Chip
                        title="Every 3 days"
                        isSelected={transaction.reminder === '3'}
                        onClick={() =>
                            onUpdateTransaction(
                                transaction.clone({ reminder: '3' }) as TransactionT
                            )
                        }
                        size="small"
                    />
                    <Chip
                        title="Once a week"
                        isSelected={transaction.reminder === '7'}
                        onClick={() =>
                            onUpdateTransaction(
                                transaction.clone({ reminder: '7' }) as TransactionT
                            )
                        }
                        size="small"
                    />
                    <Chip
                        title="Every 2 weeks"
                        isSelected={transaction.reminder === '14'}
                        onClick={() =>
                            onUpdateTransaction(
                                transaction.clone({ reminder: '14' }) as TransactionT
                            )
                        }
                        size="small"
                    />
                    <Chip
                        title="Every 30 days"
                        isSelected={transaction.reminder === '30'}
                        onClick={() =>
                            onUpdateTransaction(
                                transaction.clone({ reminder: '30' }) as TransactionT
                            )
                        }
                        size="small"
                    />
                    <Chip
                        title="Don't remind"
                        isSelected={transaction.reminder === '0'}
                        onClick={() =>
                            onUpdateTransaction(
                                transaction.clone({ reminder: '0' }) as TransactionT
                            )
                        }
                        size="small"
                    />
                </div>
            </WorkflowIconSection>
        </WorkflowPageCard>
    )
}
